import React from "react";

/**
 * VialImage — renders pre-processed vial photos with transparent backgrounds.
 * Files live in public/vials-clean/ — zero client-side processing.
 */
export default function VialImage({ src, alt, code, style, className, onClick, forceOriginal }) {
  let finalSrc = src;
  if (!forceOriginal && src) {
    finalSrc = src.replace("/vials/", "/vials-clean/").replace(".webp", ".png");
  }
  
  const isTirz = code === "RR-TR";
  const tirzStyle = isTirz && !forceOriginal ? {
    height: style && (style.maxHeight || "100%"),
    maxHeight: style && (style.maxHeight || "100%"),
    width: "auto",
    maxWidth: "none",
    objectFit: "contain"
  } : {};
  
  return (
    <img 
      src={finalSrc} 
      alt={alt || "Roche Research vial"} 
      style={{...style, ...tirzStyle}} 
      className={className} 
      onClick={onClick}
      loading="lazy"
    />
  );
}
